export default __webpack_public_path__ + "static/fabric-mf-search-for-buyers-172892eb8e6f9c70d5677bff30cfd854.png";